import React from 'react'
//@ts-ignore
import { Button } from 'dsm-react-lib'
import { IconSquarePlus } from '@tabler/icons-react'

const EmptyContent = ({ icon, title, description, buttonOnClick, maxWidth, btnLabel }: any) => {
  return (
    <div
      className={`theme-surface theme-border-selected w-fit flex flex-col items-center justify-center p-3 m-2 border rounded-lg gap-2 ${maxWidth}`}>
      <span>{icon}</span>
      <div className="flex flex-col items-center gap-25 text-center">
        <div className="font-bold text-lg text-theme-heading">{title}</div>
        <div className="text-sm text-theme-subheading">{description}</div>
      </div>
      {buttonOnClick && (
        <Button
          onClick={buttonOnClick}
          label={btnLabel || 'Add'}
          icon={<IconSquarePlus size={18} className="!text-white !stroke-white !fill-none" />}
          color="primary"
        />
      )}
    </div>
  )
}

export default EmptyContent
